import { render } from "./Navbar.vue?vue&type=template&id=d1d3c044&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=d1d3c044&scoped=true&lang=css"

import exportComponent from "/home/srodino/Tests/drinkif/frontend/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1d3c044"]])

export default __exports__